import { Dialog } from "@headlessui/react";
import { IconX } from "@tabler/icons-react";
import ContractInfoRow from "../../../../components/ContractInfoRow";
import {
  PendingContractScope,
  PendingContractState,
} from "../../../../store/pending-contract/types";
import { RootState } from "../../../../store/root-reducer";
import { connect, useDispatch } from "react-redux";
import { formatCurrency, formatDate } from "../../../../helper";
import { useEffect } from "react";
import { getPendingContractRecord } from "../../../../store/pending-contract/actions";
import { isScopeLoading } from "../../../../store/scope-loading/helpers";
import { FaSpinner } from "react-icons/fa6";
import { CONTRACT_RECORD_TYPE, PRODUCT_QUALITY } from "../../../../constant";

function PendingContractViewModal({
  isOpen,
  close,
  data,
  contract,
  loading,
}: {
  isOpen: boolean;
  close: () => void;
  data: any;
  contract: PendingContractState;
  loading: boolean;
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (data.id) {
      dispatch(getPendingContractRecord(data.id));
    }
    return () => {};
  }, [data.id, dispatch]);

  return (
    <Dialog
      open={isOpen}
      as="div"
      className="relative z-10 focus:outline-none"
      onClose={close}
    >
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-black/50">
        <div className="flex h-screen overflow-hidden items-center justify-center p-4 ">
          <div className="w-full h-full overflow-hidden rounded-xl bg-white max-w-7xl flex flex-col ">
            <div className="flex  items-center justify-between border-b border-gray-200 gap-3 p-3 text-gray-800">
              <h2 className="text-lg font-medium ">{data.id || "N/A"}</h2>
              <button onClick={close}>
                <IconX />
              </button>
            </div>
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <FaSpinner className="animate-spin text-primary size-8" />
              </div>
            ) : (
              <div className="space-y-4 my-4 overflow-y-auto h-full container">
                <div className="space-y-1">
                  <p className="font-medium text-black">Purchase Information</p>
                  <div className="bg-white border border-gray-200 rounded-xl overflow-hidden px-3 py-4 gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                    <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Invoice Number"
                      value={contract.invoiceNumber}
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Nikon Care SKU"
                      value={contract.protectallSku}
                    />
                    {/* <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Dealer SKU"
                      value={contract.dealerSku}
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Dealer Contract Number"
                      value={contract.dealerContractNumber}
                    /> */}
                    <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Record Type"
                      value={
                        CONTRACT_RECORD_TYPE.find(
                          (item) => item.value === contract.recordType
                        )?.label
                      }
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Contract Retail Price"
                      value={contract.contractRetailPrice}
                      isCurrency
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Contract Purchase date"
                      value={contract.contractPurchaseDate}
                      isDate
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Total Product Retail Value"
                      value={contract.totalProductRetailValue}
                      isCurrency
                    />
                    <ContractInfoRow
                      labelClassName="min-w-[180px]"
                      label="Invoice image"
                      value={contract.invoiceImg}
                      isLink
                    />
                  </div>
                </div>
                <div className="space-y-1">
                  <p className="font-medium text-black">Customer Information</p>
                  <div className="bg-white border border-gray-200 rounded-xl overflow-hidden px-3 py-4 space-y-4">
                    <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer First Name"
                        value={contract.customerFirstName}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer Last Name"
                        value={contract.customerLastName}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer Email"
                        value={contract.customerEmail}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer Phone"
                        value={contract.customerPrimaryTelephone}
                        isPhone
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Customer ID"
                        value={contract.customerId}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Alternative Telephone"
                        value={contract.customerAlternativeTelephone}
                        isPhone
                      />
                    </div>
                    <div>
                      <p className="font-medium text-gray-400 mb-2">
                        Customer Address
                      </p>
                      <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Street Address"
                          value={contract.customerStreetAddress1}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Address Line 2"
                          value={contract.customerStreetAddress2}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="City"
                          value={contract.customerCity}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="State"
                          value={contract.customerState}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Postal Code"
                          value={contract.customerPostalCode}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Country Code"
                          value={contract.customerCountryCode}
                        />
                      </div>
                    </div>
                    <div>
                      <p className="font-medium text-gray-400 mb-2">
                        Delivery Address
                      </p>
                      <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Street Address"
                          value={contract.customerDeliveryStreetAddress1}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Address Line 2"
                          value={contract.customerDeliveryStreetAddress2}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="City"
                          value={contract.customerDeliveryCity}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="State"
                          value={contract.customerDeliveryState}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Postal Code"
                          value={contract.customerDeliveryPostalCode}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Country Code"
                          value={contract.customerDeliveryCountryCode}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-1">
                  <p className="font-medium text-black">Store Information</p>
                  <div className="bg-white border border-gray-200 rounded-xl overflow-hidden px-3 py-4 space-y-4">
                    <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Selling Store Location"
                        value={contract.sellingStoreLocation}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Store Name"
                        value={contract.storeName}
                      />
                      <ContractInfoRow
                        labelClassName="min-w-[180px]"
                        label="Salesperson ID"
                        value={contract.salesPersonId}
                      />
                    </div>
                    <div>
                      <p className="font-medium text-gray-400 mb-2">
                        Store Address
                      </p>
                      <div className="gap-x-5 gap-y-3 grid min-[820px]:grid-cols-2 grid-cols-1">
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Street Address"
                          value={contract.sellingStoreAddress}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="City"
                          value={contract.sellingStoreCity}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="State"
                          value={contract.sellingStoreState}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Postal Code"
                          value={contract.sellingStorePostalCode}
                        />
                        <ContractInfoRow
                          labelClassName="min-w-[180px]"
                          label="Country Code"
                          value={contract.sellingStoreCountryCode}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-1">
                  <p className="font-medium text-black">Line Items</p>
                  <div className="overflow-hidden rounded-[10px] border border-gray-300 bg-white ">
                    <div className="overflow-auto">
                      <table className="w-full min-w-[800px]">
                        <thead>
                          <tr>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              No.
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Manufacturer
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Model Number
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Serial Number
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Delivery Date
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Purchase Date
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Retail Price
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Quantity
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              SKU
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Description
                            </th>
                            <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                              Quality
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {contract.lineItems.length > 0 ? (
                            contract.lineItems.map((item, index) => (
                              <tr>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {index + 1}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.manufacturer}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.modelNumber}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.serialNumber}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {formatDate(
                                    item.deliveryDateOfProduct,
                                    "N/A"
                                  )}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {formatDate(
                                    item.purchaseDateOfProduct,
                                    "N/A"
                                  )}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {formatCurrency(item.productRetailPrice)}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.quantity}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.productSku}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {item.productDescription}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                                  {
                                    PRODUCT_QUALITY.find(
                                      (subitem) =>
                                        subitem.value === item.productQuality
                                    )?.label
                                  }
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={11}
                                className="px-3 py-8 text-sm text-gray-600 border-t border-gray-200 text-center"
                              >
                                No line items found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
}

const mapStateToProps = (state: RootState) => ({
  contract: state.pendingContract,
  loading: isScopeLoading(state.scopeLoading, PendingContractScope),
});

export default connect(mapStateToProps)(PendingContractViewModal);
